import {SocialLogin} from '@capgo/capacitor-social-login';

export const GOOGLE_WEB_CLIENT_ID = '823219175804-gamlf3e5kgj264dalblr3k6ar90d5tfm.apps.googleusercontent.com';

export const GOOGLE_IOS_CLIENT_ID = '823219175804-mt76nqalo76ujtam6olq94mfm1u9dm9n.apps.googleusercontent.com';
let initializePromise: Promise<void> | undefined;

export function initializeGoogleLogin(): Promise<void> {
    if (!initializePromise) {
        initializePromise = SocialLogin.initialize({
            google: {
                webClientId: GOOGLE_WEB_CLIENT_ID,
                iOSClientId: GOOGLE_IOS_CLIENT_ID,
                iOSServerClientId: GOOGLE_WEB_CLIENT_ID,
                mode: 'online'
            }
        });
    }

    return initializePromise;
}

export async function loginWithGoogle(): Promise<string> {
    await initializeGoogleLogin();

    const response = await SocialLogin.login({
        provider: 'google',
        options: {
            scopes: ['email', 'profile'],
            prompt: 'select_account'
        }
    });

    if (response.result.responseType !== 'online' || !response.result.idToken) {
        throw new Error('Google did not return an ID token. Please try again.');
    }

    return response.result.idToken;
}

export async function logoutFromGoogle(): Promise<void> {
    await initializeGoogleLogin();
    await SocialLogin.logout({provider: 'google'});
}
